import { UserService } from 'api/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useEmployeeDepartmentsQueryKey = 'EmployeeDepartments';
export const useEmployeeDepartments = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof UserService.getUsersDepartments>>,
      QueryError,
      Awaited<ReturnType<typeof UserService.getUsersDepartments>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([useEmployeeDepartmentsQueryKey, ...(queryKey ?? [])], () => UserService.getUsersDepartments(), options);
